import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface DropdownItemIconImageProps {
  source: string;
  size?: number;
}

/*
 * Style.
 */

interface StyledWrapperDivProps {
  $size: number;
}

const StyledWrapperDiv = styled.div<StyledWrapperDivProps>`
  grid-area: left-icon;
  margin-right: 8px;
  align-self: center;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
`;

/*
 * Component.
 */

export const DropdownItemIconImage: FC<DropdownItemIconImageProps> = ({source, size = 20}) => (
  <StyledWrapperDiv $size={size}>
    <img alt="" src={source} />
  </StyledWrapperDiv>
);
